export const toAbsoluteUrl = (pathname: string) => process.env.PUBLIC_URL + pathname

export const toDomainUrl = (pathname: string) => {
    const clean = pathname.startsWith('/') ? pathname : `/${pathname}`
    return `${window.location.origin}${clean}`
}
